export default "__VITE_ASSET__BNx5xpBA__"